import React from "react";
import { SelectButton } from "primereact/selectbutton";
import { AnalyticsPeriod } from "../../../../types/analytics";
import { COCHARGE_DARK_GREEN } from "../../../../styles/theme_constants";

const currentYear = new Date().getFullYear();

const PERIOD_OPTIONS: { label: string; value: AnalyticsPeriod }[] = [
  { label: "3m", value: 3 },
  { label: "6m", value: 6 },
  { label: "12m", value: 12 },
  { label: String(currentYear), value: currentYear },
  { label: String(currentYear - 1), value: currentYear - 1 },
];

const STYLE = `
  .period-selector .p-button {
    background: white;
    border: 1px solid #dee2e6;
    color: #495057;
  }
  .period-selector .p-button:hover {
    background: #f8f9fa;
    border-color: #ced4da;
    color: #495057;
  }
  .period-selector .p-highlight {
    background: ${COCHARGE_DARK_GREEN} !important;
    border-color: ${COCHARGE_DARK_GREEN} !important;
    color: white !important;
  }
`;

interface PeriodSelectorProps {
  value: AnalyticsPeriod;
  onChange: (value: AnalyticsPeriod) => void;
  disabled?: boolean;
}

const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  value,
  onChange,
  disabled,
}) => {
  return (
    <>
      <style>{STYLE}</style>
      <SelectButton
        value={value}
        onChange={(e) => e.value !== null && onChange(e.value)}
        options={PERIOD_OPTIONS}
        disabled={disabled}
        className="period-selector"
      />
    </>
  );
};

export default PeriodSelector;
